import React, {useEffect, useState} from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import {useRecoilValue} from "recoil";
import {paymentAtom} from "../../store/PaymentStore";
import PaymentWithMil from "./PaymentWithMil";
import PaymentWithCreditCard from "./PaymentWithCreditCard";
import OnboardTabs from "../../component/base/onboard-tabs-component/OnboardTabs";
import option1 from 'assets/images/payment/payment-option-1.svg';
import option2 from 'assets/images/payment/payment-option-2.svg';
import VerifyTypeEnum from '../../enum/VerifyTypeEnum';
import {setSimulationNumber} from '../../util/SimulationManager';

const PaymentPage = (props) => {
    const {t, navigate, location, handleInformation, user} = props.props;
    const simulationNumber = setSimulationNumber();
    const payment = useRecoilValue(paymentAtom);

    const [visibleTabs, setVisibleTabs] = useState(location.state === "forgot" ? 2 : 1);

    const handleChangeTab = (tab) => {
        setVisibleTabs(tab);
        if (tab === 1) handleInformation("payment_credit_card");
        else {
            if (!isUserVerifyTypeMilesAndSmiles()) {
                handleInformation("payment_mil");
            } else {
                handleInformation("payment_mil_ok");
            }
            simulationNumber(4, 4);
        }
    }

    useEffect(() => {
        handleInformation("payment_credit_card");
        simulationNumber(3, 4);
    }, []);

    const handleCancel = () => {
        navigate("/remaining-usage");
    }

    const isUserVerifyTypeMilesAndSmiles = () => {
        return user?.verifyType === VerifyTypeEnum.MILES_A_SMILES;
    }

    return (
        <div>
            <HeaderComponent title={t('payment.title')}
                             route={"/purchase-package"}
                             content={`
                    <span class="payment-subtext">${payment?.title}</span><br/><br/>
                    <span class="payment-subtext-hint">${payment?.content}</span>
           `} showBack/>

            <div className="content-root">

                <OnboardTabs onChange={(e) => handleChangeTab(e)}
                             defaultActiveTab={visibleTabs}
                             showLine={true}
                             tabs={[
                                 {key: 1, label: t('payment.buy_with_credit_card'), icon: option1},
                                 {key: 2, label: t('payment.buy_with_mil'), icon: option2}
                             ]}
                />

                <div className="login-input-area">

                    {visibleTabs === 1 && <PaymentWithCreditCard payment={payment} props={props.props}/>}

                    {visibleTabs === 2 && <PaymentWithMil payment={payment} props={props.props}/>}

                </div>

                <div className="cancel-div">
                    <span onClick={() => handleCancel()} className="cancel">{t('return_home')}</span>
                </div>

            </div>

            <FooterComponent/>
        </div>
    );

};

export default PaymentPage;

